import { render } from "./SuperAdminSidebar.vue?vue&type=template&id=1c616a2e&scoped=true"
import script from "./SuperAdminSidebar.vue?vue&type=script&lang=js"
export * from "./SuperAdminSidebar.vue?vue&type=script&lang=js"

import "./SuperAdminSidebar.vue?vue&type=style&index=0&id=1c616a2e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c616a2e"]])

export default __exports__